export default __webpack_public_path__ + "media/images/quote-cf9bcef562d092a392b852d3167de28a.svg";